import AuthGuard from 'modules/shared/hocs/AuthGuard/AuthGuard';
import ErrorBoundary from 'modules/shared/hocs/ErrorBoundary/ErrorBoundary';
import MainLayout from 'modules/shared/layouts/MainLayout/MainLayout';
import AppLayout from './AppLayout';

// import Login from '@module/auth/Login';
// import SigninLogs from 'modules/signin-logs/components/SigninLogs/SigninLogs';
import { PermissionEnum } from '@api/enum';
import { AddAssetPurchaseOrderPage, AssetPurchaseOrderPage } from 'modules/asset-purchase-order';
import UpdateAssetPurchaseOrderPage from 'modules/asset-purchase-order/pages/update-asset-purchase-order/page';
import AuthorizeToken from 'modules/auth/AuthorizeToken';
import Login from 'modules/auth/Login';
import { CameraAddForm, CameraBimViewer, CameraEdit, CameraImagesList, CameraList } from 'modules/cameras';
import { CctvCameraAddForm, CctvCameraEditForm, CctvCameraList, CctvCameraViewer } from 'modules/cctv-cameras';
import {
    AddClientInstallationpage,
    ClientInstallationDetailPage,
    ClientInstallationPage,
} from 'modules/client-installation';
import { ClientDetails, ClientList } from 'modules/clients';
import ClientAddForm from 'modules/clients/components/ClientAddForm/ClientAddForm';
import { DroneDetails, DroneList } from 'modules/drones';
import { ViewInternalApplicationPage } from 'modules/internalApplications';
import { LinkAddForm, LinkList } from 'modules/links';
import LinkEditForm from 'modules/links/components/LinkEditForm/LinkEditForm';
import { LiveCameraList } from 'modules/live-cameras';
import Profile from 'modules/profile/components/Profile/Profile';
import {
    AddProjectInstallationPage,
    ProjectInstallationPage,
    UpdateProjectInstallationPage,
} from 'modules/project-installation';
import { ProjectAddForm, ProjectDetails, ProjectEditForm, ProjectList, SubProjectList } from 'modules/projects';
import { PublicApiRequestList } from 'modules/public-api-request';
import { ResellerCameraDetails, ResellerCameraList } from 'modules/reseller-cameras';
import NotFound from 'modules/shared/hocs/NotFound/NotFound';
import PermissionGuard from 'modules/shared/hocs/PermissionGuard/PermissionGuard';
import ClientLayout from 'modules/shared/layouts/ClientLayout/ClientLayout';
import InstallationLayout from 'modules/shared/layouts/InstallationLayout/InstallationLayout';
import OperationLayout from 'modules/shared/layouts/OperationLayout/OperationLayout';
import ProjectInstallationLayout from 'modules/shared/layouts/ProjectInstallationLayout/ProjectInstallationLayout';
import ProjectLayout from 'modules/shared/layouts/ProjectLayout/ProjectLayout';
import { ListSiteGallery, SiteGalleryDetails } from 'modules/site-gallery';
import { AddSiteReccePage, AllSiteReccePage, OperationUpdateSiteReccePage, SiteReccePage } from 'modules/site-recce';
import UpdateSiteReccePage from 'modules/site-recce/pages/update-site-recce/page';
import { SupportDetail, SupportList } from 'modules/support';
import { InternalSupport } from 'modules/internal-support';
import { AllUsers, UserAddFrom, UserEditFrom, UserList } from 'modules/users';
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom';
// import { LinkAddForm,LinkList } from 'modules/links';
// import LinkEditForm from 'modules/links/components/LinkEditForm/LinkEditForm';
// import { LiveCameraList } from 'modules/live-cameras';
import {
    AiPeopleFlowPage,
    AiServicedPage,
    BimServicedPage,
    CameraInstallationPage,
    CommentsActivityPage,
    DailyActivityPage,
    InactiveUserEmailLogsPage,
    LiveLapseLogsPage,
    MultiImageLogsPage,
    ProgressLineActivityPage,
    PublicApiLogsPage,
    ScheduledReportsPage,
    SignInLogsListPage,
    WhatsappActivityPage,
} from 'modules/analytics';
import AiEquipmentTrackingPage from 'modules/analytics/pages/ai-equipment-tracking-wrong-information/page';
import AiSafetyAnalysisPage from 'modules/analytics/pages/ai-safety-analysis-wrong-information/page';
import { DocumentListPage, DocumentUploadPage } from 'modules/box-strorage';
import { DocumentsListPage } from 'modules/documents';
import DocumentLayout from 'modules/documents/layout/DocumentLayout';
import { GridwallRequestDetailPage, GridwallRequestPage } from 'modules/gridwall-requests';
import { ProjectMap } from 'modules/project-map';
import AiWrongInformationLayout from 'modules/shared/layouts/AiWrongInformationLayout/AiWrongInformationLayout';
import AnalyticsLayout from 'modules/shared/layouts/AnalyticsLayout/AnalyticsLayout';
import { AddFloorPlanPage, EditFloorPlanPage } from 'modules/site-walk';
import { FloorPlanGuiListPage } from 'modules/site-walk-gui';
import NotificationLayout from 'modules/shared/layouts/NotificationLayout/NotificationLayout';
import {
    ClientListPage,
    ClientNotificationDetailPage,
    NotificationListPage,
    UserNotificationDetailPage,
} from 'modules/notification';
import FloorPlanLayout from 'modules/shared/layouts/FloorPlanLayout/FloorPlanLayout';
import AnnouncementLayout from 'modules/shared/layouts/AnnouncementLayout/AnnouncementLayout';
import { AnnouncementCreatePage } from 'modules/announcement';

const router = createBrowserRouter([
    {
        path: '/',
        element: <AppLayout />,
        errorElement: <ErrorBoundary />,
        children: [
            {
                path: '/login',
                element: <Login />,
            },
            {
                path: '/authorize',
                element: <AuthorizeToken />,
            },
            {
                path: '/',
                element: <AuthGuard page={<MainLayout />} />,
                children: [
                    {
                        index: true,
                        element: <Navigate to={'/clients'} replace />,
                    },
                    {
                        path: 'clients',
                        index: true,
                        element: <PermissionGuard page={<ClientList />} permissions={[PermissionEnum.CLIENT_READ]} />,
                    },

                    {
                        path: 'clients/client-add',
                        element: (
                            <PermissionGuard page={<ClientAddForm />} permissions={[PermissionEnum.CLIENT_CREATE]} />
                        ),
                    },
                    {
                        path: 'clients',
                        element: <ClientLayout />,
                        children: [
                            {
                                path: ':clientId/client-details',
                                element: <ClientDetails />,
                            },
                            // {
                            //     path: ':clientId/client-map',
                            //     element: <ClientMap />,
                            // },

                            {
                                path: ':clientId/projects',
                                element: (
                                    <PermissionGuard
                                        page={<ProjectList />}
                                        permissions={[PermissionEnum.PROJECT_READ]}
                                    />
                                ),
                            },
                            {
                                path: ':clientId/projects/add-project',
                                element: (
                                    <PermissionGuard
                                        page={<ProjectAddForm />}
                                        permissions={[PermissionEnum.PROJECT_CREATE]}
                                    />
                                ),
                            },
                            {
                                path: ':clientId/projects/:projectId/edit-project',
                                element: (
                                    <PermissionGuard
                                        page={<ProjectEditForm />}
                                        permissions={[PermissionEnum.PROJECT_UPDATE]}
                                    />
                                ),
                            },
                            {
                                path: ':clientId/projects/:projectId',
                                element: (
                                    <PermissionGuard
                                        page={<SubProjectList />}
                                        permissions={[PermissionEnum.PROJECT_READ]}
                                    />
                                ),
                            },
                            {
                                path: ':clientId/users',
                                element: (
                                    <PermissionGuard page={<UserList />} permissions={[PermissionEnum.USER_READ]} />
                                ),
                            },
                            {
                                path: ':clientId/users/add-user',
                                element: (
                                    <PermissionGuard
                                        page={<UserAddFrom />}
                                        permissions={[PermissionEnum.USER_CREATE]}
                                    />
                                ),
                            },
                            {
                                path: ':clientId/users/:userId/edit-user',
                                element: (
                                    <PermissionGuard
                                        page={<UserEditFrom />}
                                        permissions={[PermissionEnum.USER_UPDATE]}
                                    />
                                ),
                            },

                            {
                                path: ':clientId/documents',
                                element: <DocumentLayout />,
                                children: [
                                    {
                                        // path: 'clients',
                                        index: true,
                                        element: (
                                            <PermissionGuard
                                                page={<DocumentsListPage />}
                                                permissions={[PermissionEnum.DOCUMENT_READ]}
                                            />
                                        ),
                                    },
                                    // {
                                    //     path: 'upload',
                                    //     element: (
                                    //         <PermissionGuard
                                    //             page={<DocumentsUploadPage />}
                                    //             permissions={[PermissionEnum.DOCUMENT_CREATE]}
                                    //         />
                                    //     ),
                                    // },
                                ],
                            },

                            // {
                            //     path: '',
                            //     element: (
                            //         <PermissionGuard
                            //             page={<DocumentsListPage />}
                            //             permissions={[PermissionEnum.DOCUMENT_READ]}
                            //         />
                            //     ),
                            // },

                            // {
                            //     path: '',
                            //     element: <ProjectLayout />,
                            //     children: [
                            //         {
                            //             path: ':clientId/projects/:projectId/cameras',
                            //             element: <CameraList />,
                            //         },
                            //         {
                            //             path: ':clientId/projects/:projectId/cctv-cameras',
                            //             element: <CctvCameraList />,
                            //         },
                            //         {
                            //             path: ':clientId/projects/:projectId/site-galleries',
                            //             element: <ListSiteGallery />,
                            //         },
                            //         {
                            //             path: ':clientId/projects/:projectId/site-gallery/:siteItem',
                            //             element: <SiteGalleryDetails />,
                            //         },
                            //         {
                            //             path: ':clientId/projects/:projectId/drones',
                            //             element: <DroneList />,
                            //         },
                            //         {
                            //             path: ':clientId/projects/:projectId/drones/:droneId',
                            //             element: <DroneDetails />,
                            //         },
                            //     ],
                            // },
                        ],
                    },
                    {
                        path: 'clients/:clientId/projects',
                        element: <ProjectLayout />,
                        children: [
                            {
                                path: ':projectId/project-details',
                                index: true,
                                element: <ProjectDetails />,
                            },
                            {
                                path: ':projectId/project-map',
                                index: true,
                                element: <ProjectMap />,
                            },
                            {
                                path: ':projectId/cameras',
                                index: true,
                                element: <CameraList />,
                            },
                            {
                                path: ':projectId/cameras/:cameraId',
                                element: <ResellerCameraDetails />,
                            },
                            {
                                path: ':projectId/cameras/add-camera',
                                index: true,
                                element: (
                                    <PermissionGuard
                                        page={<CameraAddForm />}
                                        permissions={[PermissionEnum.TIMELAPSE_CAMERA_CREATE]}
                                    />
                                ),
                            },
                            {
                                path: ':projectId/cameras/:cameraId/edit-camera',
                                index: true,
                                element: (
                                    <PermissionGuard
                                        page={<CameraEdit />}
                                        permissions={[PermissionEnum.TIMELAPSE_CAMERA_UPDATE]}
                                    />
                                ),
                            },
                            {
                                path: ':projectId/cameras/:cameraId/bim-viewer',
                                index: true,

                                element: (
                                    <PermissionGuard
                                        page={<CameraBimViewer />}
                                        permissions={[PermissionEnum.TIMELAPSE_CAMERA_UPDATE]}
                                    />
                                ),
                            },

                            {
                                path: ':projectId/cctv-cameras/add-cctv',
                                element: (
                                    <PermissionGuard
                                        page={<CctvCameraAddForm />}
                                        permissions={[PermissionEnum.LIVE_CAMERA_CREATE]}
                                    />
                                ),
                            },
                            {
                                path: ':projectId/cctv-cameras/:cctvCameraId/edit-cctv',
                                element: (
                                    <PermissionGuard
                                        page={<CctvCameraEditForm />}
                                        permissions={[PermissionEnum.LIVE_CAMERA_CREATE]}
                                    />
                                ),
                            },
                            {
                                path: ':projectId/cctv-cameras',
                                element: <CctvCameraList />,
                            },
                            {
                                path: ':projectId/cctv-cameras/:cctvCameraId',
                                element: <CctvCameraViewer />,
                            },
                            {
                                path: ':projectId/site-galleries',
                                element: <ListSiteGallery />,
                            },
                            {
                                path: ':projectId/site-gallery/:siteItem',
                                element: <SiteGalleryDetails />,
                            },
                            {
                                path: ':projectId/drones',
                                element: <DroneList />,
                            },
                            {
                                path: ':projectId/drones/:droneId',
                                element: <DroneDetails />,
                            },
                            {
                                path: ':projectId/links',
                                element: <LinkList />,
                            },
                            {
                                path: ':projectId/links/add-link',
                                element: <LinkAddForm />,
                            },
                            {
                                path: ':projectId/links/:linkId/edit-link',
                                element: <LinkEditForm />,
                            },
                            {
                                path: ':projectId/floor-plan',
                                // element: <FloorPlanListPage />,
                                element: <FloorPlanGuiListPage />,
                            },
                            {
                                path: ':projectId/floor-plan/add-floor-plan',
                                // element: <AddFloorPlanPage />,
                                element: <AddFloorPlanPage />,
                            },
                            {
                                path: ':projectId/floor-plan/:floorPlanId',

                                element: <FloorPlanLayout />,
                                children: [
                                    {
                                        index: true,

                                        element: <EditFloorPlanPage />,
                                    },
                                ],
                            },
                        ],
                    },
                    // {
                    //     path: 'clients/:clientId/projects/:projectId/floor-plan/:floorPlanId',
                    //     element: <FloorPlanLayout />,
                    //     children: [
                    //         {
                    //             index: true,
                    //             element: <EditFloorPlanPage />,
                    //         },
                    //         {
                    //             path: 'site-walk',
                    //             element: <SiteWalkListPage />,
                    //         },
                    //         {
                    //             path: 'site-walk/add-site-walk',
                    //             element: <AddSiteWalkPage />,
                    //         },
                    //         {
                    //             path: 'site-walk/:siteWalkId/align',
                    //             element: <SiteWalkDetailPage />,
                    //         },
                    //         {
                    //             path: 'site-walk/:siteWalkId/edit',
                    //             element: <EditSiteWalkPage />,
                    //         },
                    //     ],
                    // },
                    {
                        path: 'clients/:clientId/projects/:projectId/cameras/:cameraId/images',
                        index: true,
                        element: <CameraImagesList />,
                    },
                    {
                        path: 'cameras',
                        element: (
                            <PermissionGuard
                                page={<ResellerCameraList />}
                                permissions={[PermissionEnum.RESELLER_CAMERA_READ]}
                            />
                        ),
                    },

                    {
                        path: 'live-cameras',
                        element: (
                            <PermissionGuard
                                page={<LiveCameraList />}
                                permissions={[PermissionEnum.RESELLER_CAMERA_READ]}
                            />
                        ),
                    },
                    // {
                    //     path: 'cameras/:cameraId',
                    //     element: <ResellerCameraDetails />,
                    // },
                    {
                        path: 'all-users',
                        element: <PermissionGuard page={<AllUsers />} permissions={[PermissionEnum.ALL_USERS_READ]} />,
                    },

                    {
                        path: '/all-grid-wall-requests',
                        children: [
                            {
                                index: true,
                                element: (
                                    <PermissionGuard
                                        page={<GridwallRequestPage />}
                                        permissions={[PermissionEnum.GRIDWALL_REQUEST_READ]}
                                    />
                                ),
                            },
                            {
                                path: ':gridwallId',
                                element: <GridwallRequestDetailPage />,
                            },
                        ],
                        // element: (
                        //     <PermissionGuard
                        //         page={<GridwallRequestPage />}
                        //         permissions={[PermissionEnum.GRIDWALL_REQUEST_READ]}
                        //     />
                        // ),
                    },
                    // {
                    //     path: 'sign-in-logs',
                    //     element: (
                    //         <PermissionGuard page={<SigninLogs />} permissions={[PermissionEnum.SIGN_IN_LOGS_READ]} />
                    //     ),
                    // },

                    // {
                    //     path: '/console-users',
                    //     element: (
                    //         <PermissionGuard
                    //             page={<ConsoleUserList />}
                    //             permissions={[PermissionEnum.CONSOLE_USER_READ]}
                    //         />
                    //     ),
                    // },
                    {
                        path: '/support-tickets',
                        element: <PermissionGuard page={<SupportList />} permissions={[PermissionEnum.SUPPORT_READ]} />,
                    },
                    {
                        path: '/internal-support',
                        element: (
                            <PermissionGuard page={<InternalSupport />} permissions={[PermissionEnum.SUPPORT_READ]} />
                        ),
                    },
                    {
                        path: '/internal-support/:ticketId',
                        element: (
                            <PermissionGuard page={<InternalSupport />} permissions={[PermissionEnum.SUPPORT_READ]} />
                        ),
                    },
                    {
                        path: '/box-storage',
                        // element: (
                        //     <PermissionGuard
                        //         page={<DocumentListPage />}
                        //         permissions={[PermissionEnum.BOX_STROAGE_READ]}
                        //     />
                        // ),
                        children: [
                            {
                                index: true,
                                element: (
                                    <PermissionGuard
                                        page={<DocumentListPage />}
                                        permissions={[PermissionEnum.BOX_STROAGE_READ]}
                                    />
                                ), // this will read from ?status=UNASSIGNED, etc.
                            },
                            {
                                path: 'upload',
                                element: (
                                    <PermissionGuard
                                        page={<DocumentUploadPage />}
                                        permissions={[PermissionEnum.BOX_STROAGE_CREATE]}
                                    />
                                ), // this will read from ?status=UNASSIGNED, etc.
                            },
                        ],
                    },
                    { path: 'support-tickets/:ticketId', element: <SupportDetail /> },
                    {
                        path: '/public-requests',
                        element: (
                            <PermissionGuard
                                page={<PublicApiRequestList />}
                                permissions={[PermissionEnum.PUBLIC_API_REQUEST_READ]}
                            />
                        ),
                    },

                    // All site recce
                    {
                        path: '/all-site-recce',
                        element: <AuthGuard page={<OperationLayout />} />,
                        children: [
                            {
                                index: true,
                                element: <AllSiteReccePage />, // this will read from ?status=UNASSIGNED, etc.
                            },
                            {
                                path: 'edit',
                                element: <OperationUpdateSiteReccePage />,
                            },
                        ],
                        // children: [
                        //     {
                        //         path: 'un-assigned',

                        //         element: <UnassignedSiteReccePage />,
                        //     },
                        //     {
                        //         path: 'assigned',

                        //         element: <AssignedSiteReccePage />,
                        //     },
                        //     {
                        //         path: 'completed',

                        //         element: <CompletedSiteReccePage />,
                        //     },
                        //     {
                        //         path: 'cancelled',

                        //         element: <CancelledSiteReccePage />,
                        //     },
                        // ],
                    },

                    { path: '/internal-applications', element: <ViewInternalApplicationPage /> },

                    { path: '/profile', element: <Profile /> },
                    {
                        path: '/client-installations',

                        element: <ClientInstallationPage />,
                    },
                    {
                        path: '/client-installations/add',
                        element: <AddClientInstallationpage />,
                    },

                    {
                        path: 'push-notification',
                        element: <NotificationLayout />,
                        children: [
                            {
                                path: '',
                                index: true,
                                element: <ClientNotificationDetailPage />,
                            },
                            {
                                path: 'clients',

                                element: <ClientListPage />,
                            },
                            {
                                path: 'clients/:clientId',

                                element: <UserNotificationDetailPage />,
                            },
                            {
                                path: 'notification-list',

                                element: <NotificationListPage />,
                            },
                        ],
                    },

                    {
                        path: 'announcement',
                        element: <AnnouncementCreatePage />,
                        // children: [
                        //     {
                        //         path: '',
                        //         index: true,
                        //         element: <AnnouncementCreatePage />,
                        //     },
                        // ],
                    },
                ],
            },
            {
                path: 'analytics',
                element: <AuthGuard page={<AnalyticsLayout />} />,
                children: [
                    {
                        path: 'sign-in-logs',
                        index: true,
                        element: (
                            <PermissionGuard
                                page={<SignInLogsListPage />}
                                permissions={[PermissionEnum.SIGN_IN_LOGS_READ]}
                            />
                        ),
                    },
                    {
                        path: 'live-lapse-logs',

                        element: <LiveLapseLogsPage />,
                    },
                    {
                        path: 'multi-image-logs',

                        element: <MultiImageLogsPage />,
                    },
                    {
                        path: 'scheduled-report',

                        element: <ScheduledReportsPage />,
                    },
                    {
                        path: 'ai-serviced',

                        element: <AiServicedPage />,
                    },
                    {
                        path: 'bim-servied',

                        element: <BimServicedPage />,
                    },
                    {
                        path: 'progress-line-activity',

                        element: <ProgressLineActivityPage />,
                    },
                    {
                        path: 'comments-activity',

                        element: <CommentsActivityPage />,
                    },
                    {
                        path: 'whatsapp-activity',

                        element: <WhatsappActivityPage />,
                    },
                    {
                        path: 'public-api-logs',

                        element: <PublicApiLogsPage />,
                    },
                    {
                        path: 'inactivity-triggers',

                        element: <InactiveUserEmailLogsPage />,
                    },
                    {
                        path: 'latest-installations',

                        element: <CameraInstallationPage />,
                    },
                    {
                        path: 'ai-wrong-information',

                        element: <AuthGuard page={<AiWrongInformationLayout />} />,
                        children: [
                            {
                                path: 'ai-people-flow',
                                index: true,
                                element: <AiPeopleFlowPage />,
                            },
                            {
                                path: 'ai-safety-analysis',

                                element: <AiSafetyAnalysisPage />,
                            },
                            {
                                path: 'ai-equipment-tracking',

                                element: <AiEquipmentTrackingPage />,
                            },
                        ],
                    },
                    {
                        path: 'daily-activity',

                        element: <DailyActivityPage />,
                    },
                ],
            },
            {
                path: '/client-installations/:clientInstallationId',
                element: <AuthGuard page={<InstallationLayout />} />,
                children: [
                    {
                        path: 'details',

                        element: <ClientInstallationDetailPage />,
                    },
                    {
                        path: '/client-installations/:clientInstallationId/project-installations',

                        element: <ProjectInstallationPage />,
                    },
                    {
                        path: '/client-installations/:clientInstallationId/project-installations/add',

                        element: <AddProjectInstallationPage />,
                    },
                    {
                        path: '/client-installations/:clientInstallationId/project-installations/:projectInstallationId',
                        element: <AuthGuard page={<ProjectInstallationLayout />} />,
                        children: [
                            {
                                path: 'details',

                                element: <UpdateProjectInstallationPage />,
                            },
                            // {
                            //     path: 'edit',

                            //     element: <UpdateProjectInstallationPage />,
                            // },
                            {
                                path: 'recce',

                                element: <SiteReccePage />,
                            },
                            {
                                path: 'recce/add',

                                element: <AddSiteReccePage />,
                            },
                            {
                                path: 'recce/:siteRecceId/edit',

                                element: <UpdateSiteReccePage />,
                            },
                            {
                                path: 'purchase-order',

                                element: <AssetPurchaseOrderPage />,
                            },
                            {
                                path: 'purchase-order/add',

                                element: <AddAssetPurchaseOrderPage />,
                            },
                            {
                                path: 'purchase-order/:purchaseOrderId/edit',

                                element: <UpdateAssetPurchaseOrderPage />,
                            },
                        ],
                    },
                ],
            },

            {
                path: '/404',
                element: <NotFound />,
            },
        ],
    },
]);

const AppRouter = () => {
    return <RouterProvider router={router} />;
};

export default AppRouter;
